import './intro.scss';
import { init } from 'ityped';
import { useEffect, useRef } from 'react';
export default function Intro() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      strings: [
        'Front-end Developer',
        'Back-end Engineer',
        'Mobile-App Developer',
        'Android Developer',
      ],
      backDelay: 1500,
      backSpeed: 60,
    });
  }, []);
  return (
    <div className="intro" id="intro">
      <div className="wrapper">
        <div className="left">
          <div className="imgContainer"></div>
        </div>
        <div className="right">
          <div className="wrapper">
            <h2>Hi There, I'm</h2>
            <h1>Mirza Adeel Baig</h1>
            <h3>
              <span ref={textRef}></span>
            </h3>
            <div className="button-wrapper">
              <a href="assets/Mirza-Adeel-Baig.pdf" target="_blank">
                <h4>Download CV</h4>
              </a>
              <a href="#contact">
                <h4>Contact Info</h4>
              </a>
            </div>
          </div>
        </div>
      </div>
      <a href="#about">
        <img src="assets/Arrow.png" alt="" />
      </a>
    </div>
  );
}
